import { InvoiceStatusEnum } from '@ztechapps/totalmilk-payme.contract'

export const StatusFilterOptions: { name: string; filter: Record<any, any> }[] = [
  { name: 'All', filter: {} },
  { name: 'Draft', filter: { status: InvoiceStatusEnum.Draft } },
  {
    name: 'Open',
    filter: { status: { $in: [InvoiceStatusEnum.Seen, InvoiceStatusEnum.Active, InvoiceStatusEnum.Sent] } },
  },
  { name: 'Paid', filter: { status: { $in: [InvoiceStatusEnum.Paid, InvoiceStatusEnum.PartiallyPaid] } } },
  { name: 'Overdue', filter: { status: InvoiceStatusEnum.Overdue } },
]
